<div class="row mx-0 mb-2">
  <div class="col-6 px-0 text-start">
    <app-provider-nav [provider]="provider" />
  </div>
  <div class="col-6 text-end">
    <a class="nav-link" routerLink="/capture-admin/providers/{{ provider.npi }}/audits" target="_blank">
      View Change Log
    </a>
  </div>
</div>

@if (showProviderDataReview) {
  <app-provider-data-review [provider]="provider" />
}

@if (!editing) {
  <div class="card mb-2">
    <div class="card-body">
      <div class="row">
        <div class="col-3">
          <strong> PROVIDER NAME </strong>
          <div>
            {{ provider.fullName | blankValueDash }}
            @if (provider.fullName) {
              <app-copy-to-clipboard [text]="provider.fullName" />
            }
          </div>
          <div>
            {{ provider.npi }}
            <app-copy-to-clipboard [text]="provider.npi" />
          </div>
        </div>
        <div class="col-3">
          <strong> SPECIALTIES </strong>
          <div><app-specialty-badges [specialties]="provider.specialties" [showBlank]="true" /></div>
        </div>
        <div class="col-3">
          <strong> PROVIDER STATUS </strong>
          <div>
            @if (keyedStatusOptions[provider.status]) {
              {{ keyedStatusOptions[provider.status].display }}
            } @else {
              {{ provider.status }}
            }
          </div>
        </div>
        <div class="col-2">
          <strong> STATE(S) </strong>
          <div>{{ provider.captureClientStates?.join(', ') | blankValueDash }}</div>
        </div>
        <div class="col-1 text-end">
          <a href="#" (click)="onEdit($event)"><fa-icon [icon]="['fas', 'pen']" /></a>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-3">
          <strong> CAPTURE CLIENT(S) </strong>
          <div>{{ provider.captureClientNames?.join(', ') | blankValueDash }}</div>
        </div>
        <div class="col-3">
          <strong> AFFILIATED CLIENT(S) </strong>
          <div>{{ provider.affiliatedClientNames?.join(', ') | blankValueDash }}</div>
        </div>
      </div>
    </div>
  </div>
}
@if (editing) {
  <app-provider-header-edit
    [provider]="provider"
    (canceled)="onEditDetailsCancel()"
    (updated)="onUpdatedDetails($event)" />
}
